/* globals window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import { DropdownList } from '../Widgets/Components';

import styles from './Table.scss';

const cellPositions = {
    HEADER: 'header',
    BODY: 'body',
};

export const availableContextTypes = {
    withActiveColumn: PropTypes.bool,
    position: PropTypes.string,
    firstColumnId: PropTypes.string,
    toggleColumnSelectorVisibility: PropTypes.func,
    setColumnSelectorContent: PropTypes.func,
};

// TODO: remove use of findDOMNode
/* eslint-disable react/no-find-dom-node */
export default class TableView extends Component {
    static displayName = displayName('TableView/TableView');

  static cellPositions = cellPositions; /* eslint-disable-line */

    static availableContextTypes = availableContextTypes;

    static propTypes = {
        tableId: PropTypes.string.isRequired,
        children: PropTypes.node,
        withActiveColumn: PropTypes.bool,
        onColumnSelectorStateChange: PropTypes.func,
        className: PropTypes.string,
    };

    // TODO: get rid of contexts
    static childContextTypes = {
        withActiveColumn: PropTypes.bool,
        toggleColumnSelectorVisibility: PropTypes.func,
        setColumnSelectorContent: PropTypes.func,
    };

    static defaultProps = {
        withActiveColumn: false,
        className: '',
        children: null,
        onColumnSelectorStateChange: null,
    };

    constructor(props) {
        super(props);

        this.columnSelectorNewPosition = null;

        this.state = {
            isColumnSelectorVisible: false,
            columnSelectorContent: [],
        };
    }

    getChildContext() {
        const { withActiveColumn } = this.props;

        return {
            withActiveColumn,
            toggleColumnSelectorVisibility: (position) => {
                const { isColumnSelectorVisible } = this.state;

                if (!isColumnSelectorVisible && position) {
                    this.columnSelectorNewPosition = position;
                }

                this.setState({
                    isColumnSelectorVisible: !isColumnSelectorVisible,
                });
            },
            setColumnSelectorContent: (newContent) => {
                this.setState({ columnSelectorContent: newContent });
            },
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { isColumnSelectorVisible } = this.state;
        const { onColumnSelectorStateChange } = this.props;

        if (
            isColumnSelectorVisible !== prevState.isColumnSelectorVisible &&
      onColumnSelectorStateChange
        ) {
            onColumnSelectorStateChange();
        }

        if (this.columnSelectorNewPosition) {
            window.addEventListener('click', this.closeColumnSelector);

            const $wrapper = $(findDOMNode(this.columnSelector));
            const { top: wrapperTop, left: wrapperLeft } = $wrapper.offset();
            const { top: eventTop, left: eventLeft } = this.columnSelectorNewPosition;

            $wrapper.css({
                top: eventTop - wrapperTop,
                left: eventLeft - wrapperLeft,
            });

            this.columnSelectorNewPosition = null;
        }
    }

    closeColumnSelector = ({ target }) => {
        const $wrapper = $(findDOMNode(this.columnSelector));

        if (!$wrapper.is(target) && $wrapper.has(target).length === 0) {
            window.removeEventListener('click', this.closeColumnSelector);
            this.setState({ isColumnSelectorVisible: false });
        }
    };

    render() {
        const { className, children, tableId } = this.props;
        const { isColumnSelectorVisible, columnSelectorContent } = this.state;

        const tableProps = omit(this.props, [
            'tableId',
            'withActiveColumn',
            'className',
            'styles',
            'onColumnSelectorStateChange',
        ]);

        const table = (
            <table
                className={`${styles['table-view']} ${className}`}
                data-table-id={tableId}
                {...tableProps}
            >
                {children}
            </table>
        );

        if (isColumnSelectorVisible) {
            return (
                <data>
                    {isColumnSelectorVisible && (
                        <DropdownList
                            ref={(c) => {
                                this.columnSelector = c;
                            }}
                            className={styles['column-selector']}
                            {...columnSelectorContent}
                        />
                    )}
                    {table}
                </data>
            );
        }

        return table;
    }
}
/* eslint-enable react/no-find-dom-node */
